<template>
  <ImageMedia filename="clovyr-icon.svg" />
</template>
